import axios from 'axios'
import { clone, objectSnakeToCamelCase, firstAndLastOfMonth, deleteKeyNullValues } from '@/util/libUtil.js'

const state = () => ({
	ChartVentasObjetivo: {
		ventasObjetivo: [],
		isLoading: false,
		comerciales: [],
	},
	ChartComerciales: {
		comercialesStats: [],
		isLoading: false
	},
	filters: {
		dateFilter: firstAndLastOfMonth(),
		selectedState: 'ALTA',
		selectedTipoComercial: null,
	},
	paths: {
		consecucionCountPath: '/api/atenciones/stats/consecucionCount/',
		comercialesStatsPath: '/api/atenciones/stats/rankingComerciales/',
	}
})

const mutations = {
	comercialesChartVentasObjetivos(state, payload) {
		state.ChartVentasObjetivo.comerciales = payload
	},
	filtersDateFilter(state, payload) {
		state.filters.dateFilter = payload
	},
	filtersSelectedState(state, payload) {
		state.filters.selectedState = payload
	},
	filtersSelectedTipoComercial(state, payload) {
		state.filters.selectedTipoComercial = payload
	},
	filters(state, payload) {
		state.filters = clone(payload)
	},
	ChartVentasObjetivo: (state, val) => {
		state.ChartVentasObjetivo = clone(val)
	},
	isLoadingChartVentasObjetivo(state, val) {
		state.ChartVentasObjetivo.isLoading = val
	},
	ChartComerciales: (state, val) => {
		state.ChartComerciales = clone(val)
	},
	isLoadingChartComerciales(state, val) {
		state.ChartComerciales.isLoading = val
	}
}

const actions = {
	async getVentasObjetivo({ dispatch, getters, state, commit }) {
		commit('isLoadingChartVentasObjetivo', true);
		try {
			const res = await axios.get(getters.getEndpointFromPath(state.paths.consecucionCountPath), {
				params: deleteKeyNullValues({
					'updated_on[]': state.filters.dateFilter,
					'estado': state.filters.selectedState,
					'tipo_comercial': state.filters.selectedTipoComercial
				})
			})

			commit('ChartVentasObjetivo', {
				ventasObjetivo: getters.consecucionProcessChart(res.data),
				isLoading: false,
			})

			commit('comercialesChartVentasObjetivos', getters.getComercialesFromStats(res.data))

		} catch (error) {
			console.log(error)
		}
		commit('isLoadingChartVentasObjetivo', false);
	},
	async getComercialesStats({ dispatch, getters, state, commit }) {
		commit('isLoadingChartComerciales', true);
		try {
			const res = await axios.get(getters.getEndpointFromPath(state.paths.comercialesStatsPath), {
				params: deleteKeyNullValues({
					'updated_on[]': state.filters.dateFilter,
					'estado': state.filters.selectedState,
					'tipo_comercial': state.filters.selectedTipoComercial
				})
			})

			commit('ChartComerciales', {
				comercialesStats: getters.comercialesProcessChart(res.data),
				isLoading: false,
			})
		} catch (error) {
			console.log(error)
		}
		commit('isLoadingChartComerciales', false);
	}
}

const getters = {
	getComercialesFromStats: (state) => (data) => {
		let comerciales = []
		data.forEach(element => {
			if (!comerciales.includes(element.nombre)) {
				comerciales.push(element.nombre)
			}
		});
		return comerciales;
	},
	comercialesProcessChart: (state, getters, rootState, rootGetters) => (data) => {
		data.sort((a, b) =>
			a.atenciones < b.atenciones
				? 1
				: b.atenciones < a.atenciones
					? -1
					: 0
		);

		return {
			labels: data.map(({ nombre }) => nombre),
			datasets: [
				{
					type: 'line',
					label: 'Atenciones',
					backgroundColor: 'brown',
					fill: false,
					categoryPercentage: 0.5,
					barPercentage: 1,
					data: data.map(({ atenciones }) => atenciones)
				},
				{
					type: 'bar',
					label: 'Ofertas',
					backgroundColor: 'blue',
					categoryPercentage: 0.5,
					barPercentage: 1,
					data: data.map(({ ofertas }) => ofertas)
				},
				{
					type: 'bar',
					label: 'Atenciones vendidas',
					backgroundColor: '#12c44c',
					categoryPercentage: 0.5,
					barPercentage: 1,
					data: data.map(({ atenciones_vendidas }) => atenciones_vendidas)
				},
				{
					type: 'bar',
					label: 'Ventas',
					backgroundColor: 'orange',
					categoryPercentage: 0.5,
					barPercentage: 1,
					data: data.map(({ num_ventas }) => num_ventas)
				},
				{
					type: 'bar',
					label: 'Ventas valor',
					backgroundColor: 'red',
					categoryPercentage: 0.5,
					barPercentage: 1,
					data: data.map(({ ventas_valor }) => ventas_valor)
				}
			],
		};
	},
	consecucionProcessChart: (state, getters, rootState, rootGetters) => data => {
		let elements = {};

		data.forEach((element) => {
			if (element.familia in elements) {
				elements[element.familia]['consecucion'] +=
					element.consecucion;
				elements[element.familia]['objetivo'] += element.objetivo;
			} else {
				elements[element.familia] = {};
				elements[element.familia]['consecucion'] =
					element.consecucion;
				elements[element.familia]['objetivo'] = element.objetivo;
			}
		});

		var asociacionColor = {
			'PREPAGO': 'rgb(255, 99, 132)',
			'POSPAGO': 'rgb(54, 162, 235)',
			'TV': 'rgb(255, 205, 86)',
			'DOCTOR GO': 'rgb(0, 0, 255)',
			'ENERGIA': 'rgb(255, 153, 51)',
			'FIJOS PRO': 'rgb(0, 153, 51)',
			'FIJOS PARTICULAR': 'rgb(102, 255, 51)',
			'RENUEVO': 'rgb(102, 102, 153)',
			'HOME GO': 'rgb(255, 0, 255)',
		}

		var sortable = [];
		Object.keys(elements).forEach((key) => {
			sortable.push({ name: key, ...elements[key] });
		});

		sortable.sort((a, b) =>
			a.consecucion < b.consecucion
				? 1
				: b.consecucion < a.consecucion
					? -1
					: 0
		);

		return {
			labels: sortable.map(({ name }) => name.replace('_', ' ')),
			datasets: [
				{
					label: 'Número de ventas por objetivos',
					data: Object.keys(sortable).map((el) => {
						return sortable[el].consecucion
					}),
					backgroundColor: sortable.map(({ name }) => {
						return asociacionColor[name.replace('_', ' ')]
					}),
					hoverOffset: 4,
				},
			],
		};

	},
	getEndpointFromPath: (_state, _unused, rootState) => endpoint => (
		rootState.general.host + endpoint
	)
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}